import { useQuery } from 'react-query';
import { getApiKeyInfo } from '~/api/terminal';

export const useGetApiKeyInfo = (terminalId: string) => {
  return useQuery(['apiKeyInfo', terminalId], () => getApiKeyInfo(terminalId));
};
